import { defineMessages } from 'react-intl';

export default defineMessages({
    searchContact:{
        id:'gateway.ho.package-info.Search Contact',
        defaultMessage:'Search Contact'
    }
});
